// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyAK76g5_teGAptyRgILgxLo5mfep7UNUPc",
    authDomain: "ruecart-ng.firebaseapp.com",
    databaseURL: "https://ruecart-ng-default-rtdb.firebaseio.com",
    projectId: "ruecart-ng",
    storageBucket: "ruecart-ng.firebasestorage.app",
    messagingSenderId: "332723148698",
    appId: "1:332723148698:web:53818939f5b84c72720c23",
    measurementId: "G-S6FMD62WJY"
  },
  prefix: 'dev_',
  mapKey:"AIzaSyBBEynhMRGDVyWfyOPZ6FBMWcJwxHM3zGI",
  api:'https://api-dev.order.ruecart.com/',
  clientApi:"https://ruecart-ng-client-332723148698.us-central1.run.app/",
  storeURL:'https://store-ng-dev.ruecart.com',

  endpoints:{
    INITIATE_BVN: 'create_baines_client/initiate-bvn-validation',
    BVN_VALIDATION: 'create_baines_client/bvn-otp-validation',
    QUERY_BANK_CUSTOMER: 'create_baines_client/existing-bank-customer', //Query Baines Existing bank customer
  },
  collections:{
    FORM_FIELDS:'dev_form_fields'

  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
